<template>
  <div id="signature-model">
    <ipub-model title="Edit Email Signature"
                width="870px"
                class="copyright-documents"
                :visable="isVisable"
                @cancel="cancel"
                @confirm="confirm"
                :showFooter="true">
      <div class="ipub-p4">
        <ipub-editor :height="600"
                     v-model="infoText.emailSignature">

        </ipub-editor>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mailSignature } from '@/api/mail'

export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      infoText: '',
      pamars: {}
    }
  },
  watch: {
    info (newV) {
      this.infoText = JSON.parse(JSON.stringify(newV))
      this.infoText.emailSignature = newV.emailSignature ? newV.emailSignature : ''
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      // console.log(this.infoText, 'aa')
    },
    async confirm () {
      let { emailSignature, version } = this.infoText
      this.pamars = Object.assign(this.pamars, {
        emailSignature,
        version
      })
      // console.log(this.pamars, '参数')
      await mailSignature.edit(this.infoText.id, this.pamars)
      this.$message.success({
        title: 'Success',
        content: `Set up the success`
      })
      this.$emit('cancel')
      this.$emit('list')
    },
    cancel () {
      this.infoText = JSON.parse(JSON.stringify(this.info))
      this.infoText.emailSignature = this.info.emailSignature ? this.info.emailSignature : ''
      this.$emit('cancel')
    },
  }
}
</script>